import React from "react";

const SvgSupport = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path fill="currentColor" d="M31.69 68.95h72v5h-72z" />
    <path
      d="M90 120.28H42.39a1.56 1.56 0 00-.88.28l-20.73 15.11 3.86-13.48a1.5 1.5 0 00-1.46-1.91 13.45 13.45 0 01-13.43-13.43V65.39A13.45 13.45 0 0123.18 52h88.36A13.45 13.45 0 01125 65.39v13.94h3V65.39A16.45 16.45 0 00111.54 49H23.18A16.45 16.45 0 006.75 65.39v41.46a16.45 16.45 0 0014.49 16.31L16.7 139a1.5 1.5 0 001.44 2 1.55 1.55 0 00.89-.29l23.85-17.38H90z"
      fill="currentColor"
    />
    <path
      fill="currentColor"
      d="M31.69 101.95h58.34v5H31.69zm62-16.5h-62v5h59.24a16.37 16.37 0 012.76-5zm101.13-3.12h-88.36A13.45 13.45 0 0093 95.77v41.46a13.45 13.45 0 0013.43 13.43h69.15a1.5 1.5 0 01.89.29l20.72 15.1-3.85-13.48a1.51 1.51 0 011.44-1.91 13.44 13.44 0 0013.43-13.43V95.77a13.45 13.45 0 00-13.39-13.44zM184 135.25h-72v-5h72zm0-16.5h-72v-5h72zm0-16.5h-72v-5h72z"
    />
  </svg>
);

export default SvgSupport;